import type { FC } from "react";
import styled from "@emotion/styled";
import { HeadsUpStateText, StateWrapper } from "./shared";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import loadingIconAnimation from "@/assets/images/loading-icon-tomato.lottie?url";

export const HeadsUpGeneratingView: FC = () => {
  return (
    <StateWrapper>
      <StyledLoadingContainer>
        <DotLottieReact
          src={loadingIconAnimation}
          loop={true}
          autoplay
          speed={1.0}
          style={{ width: "100%", height: "100%" }}
        />
      </StyledLoadingContainer>
      <HeadsUpStateText as="p">Finding related notes...</HeadsUpStateText>
    </StateWrapper>
  );
};

export const StyledLoadingContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
`;
